// extracted by mini-css-extract-plugin
module.exports = {"container":"_36vzl4wxpp8vBh9bWaujkG","groupsList":"U2VVhsvBCxTZpUSe7jDjF"};